import { render, staticRenderFns } from "./PdfEditor.vue?vue&type=template&id=08ef0c89&scoped=true"
import script from "./PdfEditor.vue?vue&type=script&lang=js"
export * from "./PdfEditor.vue?vue&type=script&lang=js"
import style0 from "./PdfEditor.vue?vue&type=style&index=0&id=08ef0c89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ef0c89",
  null
  
)

export default component.exports